{
  "name": "user-area-front",
  "version": "12.0.0",
  "private": true,
  "homepage": "https://www.lookiero.com/user",
  "engines": {
    "node": "^20.19.4 || ^22.13.0 || ^24.3.0 || ^25.0.0"
  },
  "scripts": {
    "install:server": "cd server && npm install",
    "android": "expo run:android",
    "ios": "expo run:ios --no-install",
    "web": "expo start --web",
    "start": "expo start",
    "start:native": "expo start --dev-client",
    "format": "prettier --write .",
    "lint": "tsc --noEmit && eslint .",
    "build": "npm run install:server && node scripts/build.js",
    "test": "jest",
    "cypress:run": "cypress run --record --key 932db7e6-3696-4c54-a19d-d5c93cae338e",
    "cypress:open": "start-server-and-test 'web' 8081 'cypress open --e2e --browser electron --env countries='[\"es\"]''",
    "prepare": "husky",
    "preweb": "node ./scripts/createIndex.js --dev domain=es",
    "postinstall": "pod-install && patch-package"
  },
  "dependencies": {
    "@braze/react-native-sdk": "^19.1.0",
    "@gorhom/portal": "^1.0.14",
    "@invertase/react-native-apple-authentication": "^2.2.2",
    "@lookiero/aurora": "^9.0.0",
    "@lookiero/aurora-iconfont": "3.2.2",
    "@lookiero/checkout": "^19.0.0",
    "@lookiero/data-sources": "0.4.1",
    "@lookiero/event": "0.3.13",
    "@lookiero/look-and-like": "^12.0.0",
    "@lookiero/look-in": "^16.0.0",
    "@lookiero/mendel-web-client": "^2.0.0",
    "@lookiero/ops-wh-support": "^1.1.0-beta.0",
    "@lookiero/payments-front": "15.1.0",
    "@lookiero/promocodes-front": "6.0.0",
    "@lookiero/quiz": "^12.0.0",
    "@lookiero/style-profile": "^8.0.0",
    "@lookiero/transport-address-update-modal": "^0.1.5",
    "@lookiero/transport-inbound-instructions-modal": "^0.1.10",
    "@lookiero/user-tracking-front": "1.0.0",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-community/netinfo": "11.5.2",
    "@react-native-community/slider": "^5.1.2",
    "@react-native-firebase/analytics": "^23.8.8",
    "@react-native-firebase/app": "^23.8.8",
    "@react-native-firebase/messaging": "^23.8.8",
    "@react-native-firebase/perf": "^23.8.8",
    "@react-native-google-signin/google-signin": "file:libs/react-native-google-signin-google-signin-22.8.0.tgz",
    "@react-native-picker/picker": "2.11.4",
    "@react-oauth/google": "^0.13.4",
    "@sentry/browser": "^10.19.0",
    "@sentry/react": "^10.19.0",
    "@sentry/react-native": "^7.3.0",
    "@stripe/stripe-react-native": "0.59.2",
    "apollo-boost": "0.4.4",
    "buffer": "6.0.3",
    "expo": "~55.0.31",
    "expo-clipboard": "~55.0.17",
    "expo-crypto": "~55.0.19",
    "expo-file-system": "~55.0.26",
    "expo-font": "~55.0.8",
    "expo-image": "~55.0.11",
    "expo-image-loader": "~55.0.1",
    "expo-keep-awake": "~55.0.8",
    "expo-linear-gradient": "~55.0.18",
    "expo-sharing": "~55.0.24",
    "expo-splash-screen": "~55.0.25",
    "expo-system-ui": "~55.0.22",
    "expo-tracking-transparency": "~55.0.18",
    "expo-updates": "~55.0.30",
    "expo-video": "~55.0.21",
    "formik": "2.4.9",
    "graphql": "14.5.8",
    "graphql-tag": "2.10.1",
    "html-react-parser": "5.2.17",
    "js-cookie": "3.0.5",
    "jwt-decode": "^4.0.0",
    "lodash.debounce": "^4.0.8",
    "react": "19.2.0",
    "react-dom": "19.2.0",
    "react-intl": "7.1.14",
    "react-native": "0.83.6",
    "react-native-device-info": "^14.1.1",
    "react-native-fbsdk-next": "^13.4.3",
    "react-native-gesture-handler": "~2.30.0",
    "react-native-get-random-values": "~1.11.0",
    "react-native-image-picker": "^8.2.1",
    "react-native-keyboard-controller": "~1.20.7",
    "react-native-localize": "^3.5.4",
    "react-native-mmkv": "3.3.3",
    "react-native-permissions": "^5.4.2",
    "react-native-reanimated": "4.2.1",
    "react-native-safe-area-context": "~5.6.2",
    "react-native-svg": "15.15.3",
    "react-native-web": "^0.21.0",
    "react-native-webview": "13.16.0",
    "react-native-worklets": "0.7.4",
    "react-router-dom": "^6.30.1",
    "react-router-native": "^6.30.1",
    "tiny-emitter": "2.1.0",
    "yup": "0.27.0"
  },
  "devDependencies": {
    "@braze/expo-plugin": "^4.0.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.0",
    "@testing-library/react-native": "^13.3.3",
    "@testing-library/user-event": "^14.6.1",
    "@types/facebook-js-sdk": "^3.3.12",
    "@types/jest": "^29.5.14",
    "@types/js-cookie": "3.0.6",
    "@types/lodash.debounce": "^4.0.9",
    "@types/node": "^22.13.14",
    "@types/react": "~19.2.10",
    "@types/react-dom": "~19.2.0",
    "@types/yup": "0.26.24",
    "@typescript-eslint/eslint-plugin": "^6.11.0",
    "@typescript-eslint/parser": "^6.11.0",
    "babel-preset-expo": "~55.0.8",
    "cypress": "15.9.0",
    "eslint": "^8.53.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-import-resolver-typescript": "^3.6.1",
    "eslint-plugin-ft-flow": "^3.0.1",
    "eslint-plugin-import": "^2.29.0",
    "eslint-plugin-jest": "^27.6.0",
    "eslint-plugin-jsx-a11y": "^6.8.0",
    "eslint-plugin-prettier": "^5.0.1",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-hooks": "^4.6.0",
    "eslint-plugin-react-refresh": "^0.4.4",
    "expo-build-properties": "~55.0.18",
    "express": "^5.1.0",
    "express-http-proxy": "^2.1.2",
    "handlebars": "^4.7.8",
    "http-proxy-middleware": "^3.0.7",
    "husky": "^9.1.7",
    "jest": "^29.4.0",
    "jest-expo": "~55.0.22",
    "lint-staged": "16.2.6",
    "node-fetch": "2.7.0",
    "patch-package": "^8.0.0",
    "pod-install": "^1.0.7",
    "prettier": "^3.1.0",
    "start-server-and-test": "^2.1.2",
    "typescript": "~5.9.2"
  },
  "overrides": {
    "@testing-library/react-native": {
      "react-test-renderer": "19.2.0"
    },
    "@lookiero/ops-wh-support": {
      "react": "19.2.0",
      "react-dom": "19.2.0",
      "react-native": "0.83.6",
      "react-native-keyboard-controller": "1.20.7",
      "react-native-reanimated": "4.2.1",
      "react-native-svg": "15.15.3",
      "react-native-worklets": "0.7.4",
      "react-native-safe-area-context": "5.6.2",
      "react-native-web": "0.21.2",
      "react-native-get-random-values": "1.11.0",
      "@react-native-picker/picker": "2.11.4",
      "expo": "55.0.31",
      "expo-font": "55.0.8",
      "expo-linear-gradient": "55.0.18",
      "expo-modules-core": "55.0.26",
      "expo-status-bar": "55.0.6"
    }
  },
  "expo": {
    "install": {
      "exclude": [
        "@sentry/react-native",
        "@stripe/stripe-react-native",
        "@react-native-community/slider",
        "@react-native-picker/picker",
        "react-native-worklets"
      ]
    },
    "doctor": {
      "reactNativeDirectoryCheck": {
        "exclude": [
          "@gorhom/portal",
          "jwt-decode"
        ],
        "listUnknownPackages": false
      }
    }
  },
  "eslintConfig": {
    "extends": "react-app"
  }
}
